import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { Tasas } from '@p-p-portafolio/interfaces/tasas';
import { TasasService } from '@p-p-portafolio/services/tasas.service';

@Component({
  selector: 'app-tasas-historico',
  templateUrl: './tasas-historico.component.html',
  styleUrls: ['./tasas-historico.component.css']
})
export class TasasHistoricoComponent implements OnInit, AfterViewInit {
  columns = [
    { field: 'clave', header: 'Clave' },
    { field: 'fechaInicia', header: 'Fecha Inicia' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'valor', header: 'Valor' },
    { field: 'formula', header: 'Fórmula' }
  ];
  public allData: number = 0;
  public loading: boolean = true;

  constructor(
    private _dialogRef: MatDialogRef<TasasHistoricoComponent>,
    private _tasasServices: TasasService,
    @Inject(MAT_DIALOG_DATA) public model: Tasas
  ) { }

  ngOnInit(): void {
    this.read();
  }

  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  read() {
    this._tasasServices.historical(this.model.clave).subscribe((res) => {
      this.dataSource.data = res.data;
      if (res.data) this.allData = res.data.length;
      if (this.allData >= 0) this.loading = false;
    });
  }

  close() {
    this._dialogRef.close();
  }

}
